import React, {FC} from 'react';

import {Note, RoundButton, Text} from '@optimaxdev/design-system';
import {Attention, Icon} from '@optimaxdev/icons';

import s from './notificationBox.scss';

/**
 * NotificationBox return notification box element
 */
export const NotificationBox: FC<{isPrescriptionNeeded: boolean}> = ({isPrescriptionNeeded}) => {
    if (!isPrescriptionNeeded) {
        return null;
    }

    return (
        <Note className={s.note} size="small" type="warning">
            <div className={s.noteContainer}>
                <Icon icon={Attention} label="attention" size="small" strokeWidth={1.9} />
                <Text lineHeight="16px" bold>
                    Prescription needed
                </Text>
            </div>
            <p className={s.noteDescription}>
                We&apos;re waiting for your prescription so we can start processing your order.
            </p>
            <RoundButton
                className={s.prescriptionButton}
                colorName="codGray"
                href="/checkout/prescription/login"
                isFull={false}
                renderAs="a"
                size="small"
                variant="ghost"
            >
                Upload Prescription
            </RoundButton>
        </Note>
    );
};
